import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../../firebase/AuthContext'

export default function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  if (currentUser){
    return <Navigate to='/'/>
  }
  return children
}